import Dashboards from "api/lib/data/Dashboards";
import { cloneWithOutReference } from "src/utils";
import { Base, IBaseProps, IBaseState } from "../Common/Base";

export interface IDashboardsBaseProps extends IBaseProps {
  orgId: string;
}

export interface IDashboardsBaseState extends IBaseState {
  dashboards: any[];
  filteredDashboards: any[];
}

export default abstract class DashboardsBase<
  Tprops extends IDashboardsBaseProps,
  TState extends IDashboardsBaseState
> extends Base<Tprops, TState> {
  protected static INITIAL_STATE = {
    ...Base.BASE_INITAL_STATE,
    dashboards: [],
    filteredDashboards: [],
  };

  constructor(props: IDashboardsBaseProps) {
    super(props);
  }

  public componentDidMount = () => {
    this.getData();
  };

  protected getData = () => {
    this.getDashboards();
  };

  public getDashboards = () => {
    const { orgId } = this.props;

    const { authUser } = this.props;
    const dashboards = new Dashboards(orgId);
    this.getList(dashboards, authUser.uid, (data: any[]) => {
      this.setState({
        dashboards: data,
        filteredDashboards: cloneWithOutReference(data),
      });
    });
  };
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardsBase.tsx